// @flow

import { documentCheckerActions } from './documentCheckerActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  consignmentData: [],
  filterData: [],
  clientFilterData: [],
  error: null
};

const documentCheckerReducer = (state = initialState, action) => {
  switch (action.type) {
    case documentCheckerActions.GET_DOCUMENT_CHECKER_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.SET_DOCUMENT_CHECKER_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.GET_FILTERS_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.SET_FILTERS_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.SET_LOADING_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.SET_CLIENT_FILTER_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.UPDATE_CONSIGNMENT_BY_INDEX: {
      const updatedConsignments = [...state.consignmentData];
      updatedConsignments[action.payload.index] = action.payload.consignment;
      return Object.assign({}, state, { consignmentData: updatedConsignments });
    }
    default: {
      return state;
    }
  }
};

export default documentCheckerReducer;
